import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Input } from "antd";
import { useDebouncedCallback } from "use-debounce";
import { RootState } from "store/Reducers";
import { handleSetMessageDetailsFilter } from "../../ClientSideStates";
import { SearchOutlined } from "@ant-design/icons";

interface SearchProps {
  contactId: number | string | null;
  advertId: number | string | null;
}

const Search = ({ contactId, advertId }: SearchProps) => {
  const { messageDetilsFilter: filter } = useSelector((state: RootState) => state.message);
  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = useState<string | undefined>(undefined);

  const debounce = useDebouncedCallback((inputValue) => {
    const value = inputValue?.trim();
    const newFilter = { ...filter };

    if (value) {
      newFilter["SearchKey"] = value;
      newFilter["PageSize"] = -1;
    } else {
      delete newFilter["SearchKey"];
      newFilter["PageSize"] = 20;
    }

    dispatch(handleSetMessageDetailsFilter({ filter: newFilter }));
  }, 1000);

  // Farklı bir mesaj grubuna geçildiğinde aramayı sıfırla
  useEffect(() => {
    setSearchValue(undefined);
    const newFilter = { ...filter };
    delete newFilter["SearchKey"];
    newFilter["PageSize"] = 20;
    dispatch(handleSetMessageDetailsFilter({ filter: newFilter }));
  }, [contactId, advertId]);

  useEffect(() => {
    if (filter?.SearchKey) {
      setSearchValue(filter.SearchKey);
    }
  }, [filter?.SearchKey]);

  return (
    <div className="!flex items-center !w-full">
      <Input
        allowClear
        prefix={<SearchOutlined className="!ml-2 !mr-4 !text-black" />}
        className="!py-2 !border-0 !w-full !bg-white !text-black !rounded-md"
        placeholder="Ara..."
        value={searchValue}
        onChange={(e) => {
          setSearchValue(e.target.value);
          debounce(e.target.value);
        }}
      />
    </div>
  );
};

export default Search;
